import { Component } from '@angular/core';

import { buildListWithLength } from '../../../utils';

@Component({
  selector: 'mwo-time-picker',
  templateUrl: './time-picker.component.html',
  styleUrls: ['./time-picker.component.scss']
})
export class TimePickerComponent {
  hours: number[] = buildListWithLength(24);
  minutes: number[] = buildListWithLength(60);
  selectedHour = 0;
  selectedMinute = 0;

  constructor(
  ) { }
}
